export default __webpack_public_path__ + "static/media/content.42f71a84.jpg";